// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"356":"fabaa9b6","424":"7404f3c4"}[chunkId] + ".chunk.css";
};